import { redirect } from '@tanstack/react-router';

import { getRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an admin has disabled the Automations section (runtime config
 * `features.automations === false`), redirect away from any `/scheduled*` route
 * (covers deep-links / bookmarks, not just the hidden nav entry).
 *
 * Fail-open — the config loader defaults the flag to `true`, so a config blip
 * leaves the route accessible (the gate is cosmetic; real auth stays server-side).
 */
export function ensureAutomationsEnabled(): void {
  if (!getRuntimeConfig().features.automations) {
    throw redirect({ to: '/' });
  }
}
